<template>
    <div class="border p-2 mb-3">
        <img v-if="bundle.image" :src="bundle.image" :alt="bundle.name" class="w-100 mb-2">
        <div class="h5 mb-1">{{ bundle.name }}</div>
        <div v-if="bundle.description">{{ bundle.description }}</div>
        <div class="mt-2">
            <div v-for="bundleProd in bundle.products/*.filter((prod) => prod.id != product.id)*/" :key="bundleProd.id">
                <div>
                    + <a :href="bundleProd.url" :title="bundleProd.name">{{ bundleProd.name }}</a>
                </div>
            </div>
        </div>
        <div class="fw-bold mt-2">
            <div v-if="bundle.type == 'flat_rate'" v-html="__('cart', 'flat_off', {'flatOff': amountWithCurrency(bundle.discount_flat)})"></div>
            <div v-if="bundle.type == 'percentage' && locale != 'tw'" v-html="__('cart', 'percent_off', {'percentOff': bundle.discount_percentage})"></div>
            <div v-if="bundle.type == 'percentage' && locale == 'tw'" v-html="__('cart', 'percent_off', {'percentOff': (100 - bundle.discount_percentage) / 10})"></div>
            <div v-if="bundle.type == 'free_product'" v-html="__('cart', 'free_product', {'freeProdUrl': bundle.free_product.url, 'freeProdName': (bundle.free_product.name)})"></div>
        </div>
        <div class="small text-muted">(-{{ amountWithCurrency(bundle.value) }})</div>
        <div v-if="loaded && cart.discounts.find((discount) => discount.source == 'bundle' && discount.model_id == bundle.id)" class="mt-2 text-success">
            <b>{{t.bundles.bundle_cart}}</b>
        </div>
        <div v-else class="mt-2">
            <div class="btn btn-primary btn-sm" @click="addBundle(bundle.id)">{{t.bundles.add_bundle}}</div>
        </div>
    </div>
</template>
<script>
import store from '../CartStore'
export default {
    props: ['dataBundle', /*'dataProduct'*/],
    store: store,
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            // product: this.dataProduct,
            bundle: this.dataBundle,
        };
    },
    computed: {
        ...Vuex.mapGetters(['loaded', 'cart']),
    },
    methods: {
        ...Vuex.mapActions(['addBundle']),
    },
};
</script>
